import React, { useMemo } from 'react';

export default function QueueItem({ item, onPickUp }) {
  const waitingLabel = useMemo(() => {
    const mins = item.waiting_minutes || 0;
    if (mins < 1) return 'agora';
    if (mins === 1) return '1 min';
    return `${mins} min`;
  }, [item.waiting_minutes]);

  return (
    <div
      style={{
        padding: '10px 12px',
        borderRadius: '8px',
        border: '0.5px solid #F7C1C1',
        background: '#FCEBEB',
        marginBottom: '6px',
      }}
    >
      {/* Linha 1: Nome + tempo */}
      <div
        className="d-flex justify-content-between align-items-center"
        style={{ marginBottom: '6px' }}
      >
        <span style={{ fontSize: '13px', fontWeight: 600, color: '#791F1F' }}>
          {item.customer_name || item.customer_phone || 'Cliente'}
        </span>
        <span style={{ fontSize: '10px', color: '#A32D2D' }}>
          {waitingLabel}
        </span>
      </div>

      {/* Linha 2: Pedido */}
      {item.order_number && (
        <div
          style={{ fontSize: '11px', color: '#791F1F', marginBottom: '4px' }}
        >
          Pedido #{item.order_number}
        </div>
      )}

      {/* Linha 3: Subscriber + Loja */}
      <div
        className="d-flex align-items-center"
        style={{ gap: '6px', marginBottom: '8px', flexWrap: 'wrap' }}
      >
        {item.subscriber_name && (
          <span
            style={{
              fontSize: '10px',
              color: '#791F1F',
              background: 'rgba(255,255,255,0.5)',
              padding: '1px 6px',
              borderRadius: '8px',
            }}
          >
            {item.subscriber_name}
          </span>
        )}
        {item.store_name && (
          <span
            style={{
              fontSize: '10px',
              color: '#A32D2D',
              background: 'rgba(255,255,255,0.5)',
              padding: '1px 6px',
              borderRadius: '8px',
            }}
          >
            {item.store_name}
          </span>
        )}
      </div>

      {/* Botão */}
      <button
        type="button"
        onClick={() => onPickUp(item.id)}
        style={{
          fontSize: '11px',
          padding: '4px 14px',
          borderRadius: '6px',
          border: '0.5px solid #A32D2D',
          background: '#fff',
          color: '#A32D2D',
          cursor: 'pointer',
        }}
      >
        Pegar atendimento
      </button>
    </div>
  );
}
